import * as React from 'react';
import { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { color } from '@core-ds/primitives';
import { Toolbox } from '@core-ds/icons/24';
import Dropdown from './dropdown';
import Workbench from 'Shared/workbench';

const Icon = styled(Toolbox)`
   cursor: pointer;
   color: ${color.gray4};
`;

const mapStateToProps = state => ({
   userTopics: state.headerState.userTopics,
});

class WorkbenchDropdown extends Component {
   render() {
      return (
         <Dropdown
            icon={<Icon id="workbenchDropdownToggle" aria-label="my workbench" focusable="false" />}
         >
            <Workbench topics={this.props.userTopics} />
         </Dropdown>
      );
   }
}

export default connect(mapStateToProps)(WorkbenchDropdown);
